import { createEntityAdapter, type EntityAdapter } from 'redux-ngrx-entity';
import type { Property } from '../models.ts';

export const entity: EntityAdapter<Property> = createEntityAdapter<Property>({
  selectId: property => property.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name)
});
